import { search } from "../../BaseRepositoryComponents";
const searchParams = new URLSearchParams(window.location.search);

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

const customerPath = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/cliente`;

const multitenantHeaders = new Headers();
multitenantHeaders.append("Authorization", token);
multitenantHeaders.append("content-type", "application/json");

export async function findClientsV3({
  fields = ["id", "apelido", "razao", "cpfcnpj"],
  perPage = 1000,
  filters = {
    ativo: "strict:S",
  },
}) {
  const url = new URL(customerPath);

  url.searchParams.append("fields", fields);
  Object.entries(filters).forEach(([name, value]) =>
    url.searchParams.append(`filter[${name}]`, value)
  );
  url.searchParams.append("perPage", perPage || 1000);

  return search(decodeURIComponent(url), "GET", multitenantHeaders);
}

export async function checkAccountant({ document }) {
  const url = `${customerPath}/${document}/check-accountant`;
  return search(url, "GET", multitenantHeaders);
}
